<template >
  <div class="formPosition" v-role="'ped'">
    <template>
      <v-container class="grey lighten-5">
        <v-row no-gutters>
          <v-col>
            <h4 style="text-align:center;"> <span>Movimentações de Contas Bancárias</span></h4>
            <div class="text-center">
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-container fluid>
                <v-row>
                  <v-col class="d-flex" cols="12" sm="6" md="10">
                    <v-btn fab to="/visualizar-contas" color="primary"> <v-icon large>arrow_back</v-icon> </v-btn>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-menu offset-y origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <v-btn fab dark color="teal" style="color:white" v-on="on">
                          <v-icon>print</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="dialog_ = true"><img width="30px" src="../../assets/excel.png"> <span
                            style="margin-left:10px;">Impimir em Excel</span></v-list-item>
                        <v-list-item @click="gerarHTML()"><img width="30px" src="../../assets/pdf.png"><span
                            style="margin-left:10px;"> Impimir em PDF</span></v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>

        <v-card class="mx-auto">
          <v-list-item>
            <v-list-item-avatar color="grey"></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline">Banco : {{ nomeDoBanco }}</v-list-item-title>
              <v-list-item-subtitle>Conta: {{ numeroDaConta }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-row>
                <v-col md="4">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="dataInicio" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dataInicio" label="Seleciona a data inicial" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="dataInicio" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(dataInicio)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="4">
                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="dataFim"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dataFim" label="Seleciona a data final" readonly v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="dataFim" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.menu2.save(dataFim)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="2">
                  <v-btn small fab color="green" @click="ObterMovimentosBancarios()"
                    style="color:white;"><v-icon>search</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>

          <v-row>
            <v-col md="12">
              <v-card-text>
                <strong><v-chip color="green" style="margin:4px;color:white">Movimentos realizados</v-chip></strong>
              </v-card-text>
              <div style="text-align: center;">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="isLodingPDF"></v-progress-circular>
              </div>
              <hr>
              <v-row>
                <v-col md="12">
                  <v-data-table :headers="headers_" :items="this.movimentos">
                    <template v-slot:item.indice="{ item }">
                      <span>{{ movimentos.indexOf(item) + 1}}</span>
                    </template>
                    <template v-slot:item.data_compra="{ item }">
                      <span>{{ formatarData(item.data_compra) }}</span>
                    </template>
                    <template v-slot:item.subTotal="{ item }">
                      <span>{{ utilitarios.IntegerToMoneyValueFatura(item.subTotal) }}</span>
                    </template>
                    <template v-slot:item.valorPago="{ item }">
                      <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valorPago) }}</span>
                    </template>
                    <template v-slot:item.multa="{ item }">
                      <span>{{ utilitarios.IntegerToMoneyValueFatura(item.multa) }}</span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <hr>
              <template>
                <v-row>
                  <v-col md="4">
                    <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de movimentações:
                      <v-chip>{{ this.movimentos.length }}</v-chip></span>
                  </v-col>
                  <v-col md="4">
                  </v-col>
                  <v-col md="4">
                    <span style="font-size:20px;font-weight:bold;">Total Arrecadado: <v-chip color="#006699"
                        style="color:white;">{{ utilitarios.IntegerToMoneyValueFatura(totalGeral) }}</v-chip></span>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </template>
  </div>
</template>

<script>
import axios from '../../plugins/axios';
import utilitarios, { IntegerToMoneyValue } from '../../plugins/utilitarios';
import { mask } from 'vue-the-mask';
import { VMoney } from 'v-money';
const ls = require('local-storage');
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    nomeDoBanco: '',
    numeroDaConta: 0,
    config: null,
    isLodingPDF: false,
    dataInicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dataFim: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: null,
    price: 0,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    valorEntregue: 0,
    select1: null,
    pesquisa_parameto: null,
    estudantePesquisa: null,
    dataPagamentoSelected: null,
    troco: 0,
    precoPropinaFiltered: [],
    numeroRecibo: [],
    recibos: [],
    estudante_dados: [],
    estudantesLista: [],
    meioPagamentoSelected: null,
    multasFiltered: [],
    meiosPagamentos: [],
    itemPagamento: null,
    itemPagamentoSelected: null,
    showValorReadyOnly: false,
    identificadorCliente: null,
    utilitarios: utilitarios,
    multaAplicada: null,
    precosPropina: [],
    estudanteSelecionado: [],
    pagamentosFeitos: [],
    precoMulta: [],
    bancoSelected: null,
    contaSelected: null,
    contasFiltered: null,
    meses: [],
    mesesPago: [],
    bancos: [],
    contas: [],
    precoPropina: [],
    estudantes: [],
    mesesAPagar: [],
    dialogRecibo: false,
    overlay: false,
    overlay2: false,
    showCamposRecibos: false,
    idMatricula: null,
    msg_pesquisa: true,
    isLoading_: false,
    search: '',
    pesquisa: '',
    estudante: true,
    valid: false,
    valid2: true,
    dialog: false,
    progresso: false,
    Pessoas: [],
    movimentos: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers_: [
      { text: '#', value: 'indice' },
      { text: 'Identificação Doc.', value: 'numeroDocumento' },
      { text: 'Estudante', value: 'estudante' },
      { text: 'Data', value: 'data_compra' },
      { text: 'Pago', value: 'valorPago' },
      { text: 'Multa', value: 'multa' },
      { text: 'Total Pago', value: 'subTotal' },
      { text: 'Registrado por:', value: 'nomeUsuario' }
    ]
  }),

  computed: {
    totalGeral() {
      let valor = 0;
      this.movimentos.forEach(element => {
        valor += parseInt(element.valorPago);
      })
      return valor;
    }
  },
  created() {
    // Checando se o store trás dados
    if (!this.$store.state.itemBanco) {
      this.$router.push('/visualizar-contas');
    } else {
      this.nomeDoBanco = this.$store.state.itemBanco.nome;
      this.numeroDaConta = this.$store.state.itemBanco.numeroConta;
      this.getConfig();
    }
  },
  methods: {
    // Trazendo os dados bancários da conta
    async ObterMovimentosBancarios() {
      this.isLodingPDF = true;
      let params = {
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        numeroDaConta: this.numeroDaConta
      };

      try {
        this.movimentos = await axios.post('/movimentacoes-conta', params).then((res) => res.data);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a filtragem dados.');
      } finally {
        this.isLodingPDF = false;
        if (this.movimentos.length === 0) {
          utilitarios.showAlertMessage('warning', 'Dados não encontrado!');
        }
      }
    },

    // Os dados vêm originalmento no formato "2022-11-21T10:25:40.000Z"
    // Método responsavél por converter no formato "2022-11-21"
    formatarData(data){
      let newData = data.split('T');
      return newData[0];
    },

    // Método responsavél por pegar o nome e o logotipo da instituição logada no sistema
    getConfig() {
      try {
        if (window.location.host.includes('localhost')) {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA' }
        } else if (window.location.host.includes('isppluena.com')) {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
        } else if (window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10')) {
          this.config = { logo: 'logoAt.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA' }
        } else if (window.location.host.includes('ispamazozo.com')) {
          this.config = { logo: 'logoMazozo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA-MAZOZO' }
        } else {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
        }
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      }
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      this.isLodingPDF = true;
      try {
        let header = ``;
        let dados = ``;
        let lastRow = ``;
        let i = 1;
        let periodo = ` 
            <table class="table2">
              <tr>
                <td>
                  <div class="logo">
                    <span><img src="http://ims.eftsk.com/readfile/`+ this.config.logo + `" alt="Logótipo da Universidade" class="logo_img"/></span>
                    <br><span>`+ this.config.descricao + `</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="dados_academicos">
              <span class="bold-font-table">Movimentações de contas Bancárias</span>
              <br><span><span class="bold-font-table">Banco:</span> ${this.nomeDoBanco}</span> 
              <br><span><span class="bold-font-table">Conta:</span> ${this.numeroDaConta}</span> 
              <br><span><span class="bold-font-table">De:</span> ${this.formatarData(this.dataInicio)}</span> 
              <br><span><span class="bold-font-table">Até:</span> ${this.formatarData(this.dataFim)}</span> 
              <br><span><span class="bold-font-table">Gerada em:</span> ${this.data_hora()}</span> 
            </div>`
        header = ` 
            <th class="table_header border_on_table">#</th>
            <th class="table_header border_on_table">Identificação Doc.</th>  
            <th class="table_header border_on_table">Estudante</th>  
            <th class="table_header border_on_table">Data</th>  
            <th class="table_header border_on_table">Pago</th>  
            <th class="table_header border_on_table">Multa</th>  
            <th class="table_header border_on_table">Total Pago</th>
            <th class="table_header border_on_table">Autor</th>`
        this.movimentos.forEach(element => {
          dados += `
            <tr>
              <td class="border_on_table">` + i + `</td>
              <td class="table_data border_on_table" >` + element.numeroDocumento + `</td>
              <td class="table_data data_disciplina border_on_table">` + element.estudante + `</td>
              <td class="table_data border_on_table">` + this.formatarData(element.data_compra) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.utilitarios.IntegerToMoneyValueFatura(element.valorPago) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.utilitarios.IntegerToMoneyValueFatura(element.subTotal) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.utilitarios.IntegerToMoneyValueFatura(element.multa) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + element.nomeUsuario + `</td>
            </tr>`
          i++
        })
        lastRow = `
          <tr class="border_on_table">
            <th colspan="6" style="text-align:right" bgcolor="#DCDCDC">Total Geral:</th>
            <td style="text-align:right" bgcolor="#DCDCDC"> ${this.utilitarios.IntegerToMoneyValueFatura(this.totalGeral)}</td>
          </tr>`

        this.html = `
            <html>
              <head>
                <style>
                * {
                    font-family: "Times New Roman", sans-serif;
                  }
                  .table_header {
                    padding: 5px 3px;
                    text-align: center;
                    background-color: #DCDCDC;
                  }
                  .table_data {
                    text-align: center;
                    padding: 5px;
                  }
                  tr td.data_disciplina {
                    text-align: left;
                  }
                  .logo {
                    width: 100%;
                    text-align: center;
                    margin-bottom: 10px;
                  }
                  .logo_img {
                    width:90%;
                    max-width:50px;
                  }
                 
                  .dados_academicos {
                    border-radius: 15px;
                    border: 1px solid #000000;
                    padding: 15px; 
                    font-size:10px
                  }
                  .table1 {
                    width: 100%;
                    margin-top: 30px;
                  }
                  .table2 {
                    border: 0px solid black;
                    margin-left: 0px;
                    margin-right: auto;
                    width: 100%
                  }
                  .legenda {
                    margin-top: 20px;
                    font-size: 10px;
                  }
                  .border_on_table {
                    border: 1px solid #000;
                    text-align: center;
                  }
                  table, th, td {
                    border: 0px solid black;
                    border-collapse: collapse;
                    font-size: 8px;
                  }
                  .bold-font-table {
                    font-weight: bold;
                  }
                </style>
              </head>
              <body>
                ` + periodo + `
                <table class="table1">
                  <tr> ` + header + ` </tr>
                  <tr> ` + dados + ` </tr>
                  <tr> ` + lastRow + ` </tr>
                </table>
              </body>
            </html> `
        this.htmlToPDF()
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      }
    },

    // Método responsavél por converter o HTML gerado pelo método gerarHTML() em um arquivo PDF
    async htmlToPDF() {
      try {
        let options = {
          'format': 'A4',
          'border': {
            'right': '9mm',
            'left': '9mm'
          },
          'header': {
            'height': '10mm'
          },
          'footer': {
            'height': '1mm'
          }
        }
        await axios({
          method: 'post',
          url: 'https://ims.eftsk.com/writefile',
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: options
          }
        }).then(function (response) {
        })
        this.frame()
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      }
    },

    // Método responsavél por criar a base HTML e renderizar o arquivo em outra aba
    frame() {
      try {
        let url = 'https://ims.eftsk.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
        let frame = `
            <html> +
              <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}</style>
              <body>
                <iframe target= "_blank" type="application/pdf" src="` + url + `"></iframe>
              </body>
            </html>`
        let a = window.open('about:blank', '_blank', '', true)
        a.document.write(frame)
        a.document.close()
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.isLodingPDF = false;
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }

}

</script>
